import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import React from 'react';

const PracticeAreaCard = ({ practiceArea, onLearnMore }) => {
	return (
		<div className='bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100 overflow-hidden group'>
			{/* Image Header */}
			<div className='relative h-48 overflow-hidden'>
				<Image
					src={practiceArea?.image}
					alt={practiceArea?.title}
					className='w-full h-full object-cover group-hover:scale-105 transition-transform duration-500'
				/>
				<div className='absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent'></div>
				<div className='absolute top-4 right-4'>
					<div className='w-12 h-12 bg-[#800020] rounded-lg flex items-center justify-center shadow-lg'>
						<Icon name={practiceArea?.icon} size={24} color='white' strokeWidth={2.5} />
					</div>
				</div>
			</div>

			<div className='p-6'>
				<h3 className='font-playfair font-bold text-xl text-[#800020] mb-3 group-hover:text-[#800020]/90 transition-colors duration-300'>
					{practiceArea?.title}
				</h3>

				<div className='flex items-center justify-end'>
					<Button
						variant='outline'
						size='sm'
						onClick={() => onLearnMore(practiceArea)}
						className='text-[#800020] border-[#800020] hover:bg-[#800020] hover:text-white transition-all duration-300'
						iconName='ArrowRight'
						iconPosition='right'
						iconSize={14}
					>
						Learn More
					</Button>
				</div>
			</div>
			<div className='h-1 bg-gradient-to-r from-[#800020] via-[#DB954E] to-[#800020] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left'></div>
		</div>
	);
};

export default PracticeAreaCard;
